var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearchicon = function SvgSearchicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M10.383 16.767a6.382 6.382 0 0 0 3.71-1.196l3.935 3.935a.941.941 0 0 0 .673.274c.54 0 .93-.415.93-.947a.914.914 0 0 0-.266-.664l-3.91-3.918a6.358 6.358 0 0 0 1.312-3.868c0-3.51-2.872-6.383-6.384-6.383C6.863 4 4 6.872 4 10.383c0 3.512 2.864 6.384 6.383 6.384Zm0-1.378c-2.747 0-5.005-2.266-5.005-5.006 0-2.739 2.258-5.005 5.005-5.005 2.74 0 5.006 2.266 5.006 5.005 0 2.74-2.266 5.006-5.006 5.006Z"
  })));
};
export { SvgSearchicon as ReactComponent };
export default __webpack_public_path__ + "9fe3f6f5b89c23bdd2fdc35c3bf8e748.svg";